import { cache } from "react"
import configuredAxios from "helpers/configuredAxios"

export const fetchJobDetail = cache(async ({ job_id }) => {
  const axios = await configuredAxios('apiGo')
  return axios.get(`/web/simple_job_detail/${job_id}?source=web3`)
})